document.addEventListener('DOMContentLoaded', (evt) => {
    if (location.href.includes('/pages/')) {
        const form = document.querySelector('#ContactForm.wholesalers')
        if (!form) return
        const socialNetworksInputs = form.querySelectorAll('.contact__fields-social-networks input[type="text"]')
        const socialNetworksCheckbox = form.querySelectorAll('.contact__fields-social-networks input[type="checkbox"]')
        if(!socialNetworksCheckbox) return
        socialNetworksCheckbox.forEach((inputCheckbox, index) => {
            inputCheckbox.addEventListener('change', (evt) => {
                inputCheckbox.checked ? socialNetworksInputs[index].setAttribute('disabled', '') : socialNetworksInputs[index].removeAttribute('disabled')
            })
        });
    }
})

